$shm_projects_digest_view $mol_section
	title \Итоги недели
	digest null
	tools /
		<= Refresh $mol_button_minor
			title \Обновить
			click? <=> refresh? null
	content /
		<= Notes $shm_projects_release_notes_view
			notes <= notes null
			scope_text <= updated_text \
			content_text <= content_text \
